import { useState } from 'react';

import { useUserAgent } from '@simplywallst/hooks/useUserAgent';
import { useIsMobileScreen } from '@/hooks/useMedia';

import { CompanyIcon } from '@/components/CompanyIcon';

import { InstructionsModal } from '../components/InstructionsModal';
import { useTypeformDrawer } from '@/hooks/useTypeformDrawer';

import type { Transaction } from '../hooks';

export const Header = ({ company }: { company: Transaction }) => {
  const { symbol, exchangeCode, holding } = company;
  const [showModal, setShowModal] = useState(false);

  const { isMobile } = useUserAgent();
  const isMobileScreen = useIsMobileScreen({ defaultMatches: isMobile });

  const popUpFeedbackForm = useTypeformDrawer('ayijp5kv');

  return (
    <header className="grid grid-rows-[max-content_max-content] gap-x2 p-x3 md:grid-cols-[max-content_1fr] md:grid-rows-[auto] md:items-center md:gap-x5 md:px-x5 md:py-x4">
      <div className="grid grid-cols-[max-content_auto] items-center gap-x2">
        <CompanyIcon
          tickerSymbol={symbol ?? undefined}
          website={holding?.company.info?.url ?? undefined}
          size={48}
        />
        <div>
          <h1 className="m-x0 text-xl text-solid">
            <strong>{`Edit ${holding?.providerCompanyName} Transactions`}</strong>
          </h1>
          <p className="m-x0 text-xs text-soft">
            Only showing <strong>{`${exchangeCode}:${symbol}`}</strong>
          </p>
        </div>
      </div>
      <div className="grid grid-cols-[max-content_max-content] justify-between gap-x4 md:justify-end">
        <button
          className="grid grid-cols-[max-content] items-center"
          onClick={() => setShowModal(true)}
        >
          <p className="m-x0 text-xs text-soft">How to add my transactions?</p>
        </button>
        <button
          className="grid grid-cols-[max-content] items-center"
          onClick={popUpFeedbackForm}
        >
          <p className="m-x0 text-xs text-soft">
            {isMobileScreen ? 'Feedback' : 'Give feedback'}
          </p>
        </button>
      </div>
      {showModal && <InstructionsModal onClose={() => setShowModal(false)} />}
    </header>
  );
};
